import React from 'react';
import { motion } from 'framer-motion';
import { Layers, GitMerge, PenTool, Target } from 'lucide-react';
export function WhatsInside() {
  const items = [{
    icon: <Layers className="w-5 h-5 text-gold" data-id="element-149" />,
    text: '10 structured modules'
  }, {
    icon: <GitMerge className="w-5 h-5 text-gold" data-id="element-150" />,
    text: 'Clear interpretation method'
  }, {
    icon: <PenTool className="w-5 h-5 text-gold" data-id="element-151" />,
    text: 'Fill-in decoding templates'
  }, {
    icon: <Target className="w-5 h-5 text-gold" data-id="element-152" />,
    text: 'Real-life applications'
  }];
  return <section className="py-14 px-2 sm:px-6 lg:px-8 bg-dark-card border-y border-dark-border" data-id="element-153">
      <div className="max-w-4xl mx-auto mt-[-30px] mb-[-30px]" data-id="element-154">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mt-[0px] mb-[0px]" data-id="element-155">
          <h2 className="text-3xl sm:text-4xl font-serif mb-4" data-id="element-156">
            What's Inside
          </h2>
          <div className="w-12 h-1 bg-gold mx-auto rounded-full" data-id="element-157"></div>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-[21px] mb-[21px]" data-id="element-158">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-center gap-4 p-6 rounded-xl bg-dark border border-dark-border" data-id="element-159">
              <div className="w-10 h-10 rounded-full bg-gold/10 flex items-center justify-center shrink-0" data-id="element-160">
                {item.icon}
              </div>
              <span className="text-lg font-medium text-zinc-200" data-id="element-161">
                {item.text}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}